import { html, TemplateResult } from 'lit';

export function renderVisitorRegistrationForm( parent: HTMLElement, handleSubmit: ( e: Event ) => void, withErrors: Array<string> ): TemplateResult {
	let feedback = html``;

	if ( withErrors && 0 < withErrors.length ) {
		const messagesHTML = withErrors.map( ( error, index ) => {
			if ( index === withErrors.length - 1 ) {
				return html`${error}`;
			}

			return html`${error}<br>`;
		} );

		feedback = html`
			<div class="alert is-error">
				${messagesHTML}
			</div>
		`;
	}

	let termsAndConditionsLinkHTML = html``;
	if ( window.translations.registrationForm.termsAndConditionsLink ) {
		termsAndConditionsLinkHTML = html`
			<a href="${window.translations.registrationForm.termsAndConditionsLink.url}">
				${window.translations.registrationForm.termsAndConditionsLink.title}
			</a>
		`;
	}

	let privacyPolicyLinkHTML = html``;
	if ( window.translations.registrationForm.privacyPolicyLink ) {
		privacyPolicyLinkHTML = html`
			<a href="${window.translations.registrationForm.privacyPolicyLink.url}">
				${window.translations.registrationForm.privacyPolicyLink.title}
			</a>
		`;
	}

	const campusesBySchool: Record<string, Record<string, string>> = {
		'Antwerp Maritime Academy': {
			Bredastraat: window.translations.registrationForm.campusOptions.Bredastraat ?? 'Bredastraat',
			Noordkasteel: window.translations.registrationForm.campusOptions.Noordkasteel ?? 'Noordkasteel',
		},
		'Artesis Plantijn Hogeschool Antwerpen': {
			deSingel: window.translations.registrationForm.campusOptions.deSingel ?? 'deSingel',
			Dambruggestraat: window.translations.registrationForm.campusOptions.Dambruggestraat ?? 'Dambruggestraat',
			Hallen: window.translations.registrationForm.campusOptions.Hallen ?? 'Hallen',
			Keizerstraat: window.translations.registrationForm.campusOptions.Keizerstraat ?? 'Keizerstraat',
			'Lange Nieuwstraat': window.translations.registrationForm.campusOptions['Lange Nieuwstraat'] ?? 'Lange Nieuwstraat',
			Meistraat: window.translations.registrationForm.campusOptions.Meistraat ?? 'Meistraat',
			Mode: window.translations.registrationForm.campusOptions.Mode ?? 'Mode',
			Mutsaard: window.translations.registrationForm.campusOptions.Mutsaard ?? 'Mutsaard',
			'Spoor Noord - Ellermanstraat': window.translations.registrationForm.campusOptions['Spoor Noord - Ellermanstraat'] ?? 'Spoor Noord - Ellermanstraat',
			'Spoor Noord - Lichttoren': window.translations.registrationForm.campusOptions['Spoor Noord - Lichttoren'] ?? 'Spoor Noord - Lichttoren',
			'Spoor Noord - Noorderplaats': window.translations.registrationForm.campusOptions['Spoor Noord - Noorderplaats'] ?? 'Spoor Noord - Noorderplaats',
			'Spoor Noord - Viaduct': window.translations.registrationForm.campusOptions['Spoor Noord - Viaduct'] ?? 'Spoor Noord - Viaduct',
		},
		'Karel de Grote Hogeschool': {
			Bernarduscentrum: window.translations.registrationForm.campusOptions.Bernarduscentrum ?? 'Bernarduscentrum',
			Groenplaats: window.translations.registrationForm.campusOptions.Groenplaats ?? 'Groenplaats',
			Hoboken: window.translations.registrationForm.campusOptions.Hoboken ?? 'Hoboken',
			Niel: window.translations.registrationForm.campusOptions.Niel ?? 'Niel',
			Pothoek: window.translations.registrationForm.campusOptions.Pothoek ?? 'Pothoek',
			'Sint-Jozef': window.translations.registrationForm.campusOptions['Sint-Jozef'] ?? 'Sint-Jozef',
			'Sint-Lucas': window.translations.registrationForm.campusOptions['Sint-Lucas'] ?? 'Sint-Lucas',
			Stadswaag: window.translations.registrationForm.campusOptions.Stadswaag ?? 'Stadswaag',
			Zuid: window.translations.registrationForm.campusOptions.Zuid ?? 'Zuid',
		},
		'KU Leuven Antwerpen': {
			Carolus: window.translations.registrationForm.campusOptions.Carolus ?? 'Carolus',
			Opera: window.translations.registrationForm.campusOptions.Opera ?? 'Opera',
			'Sint-Jacob': window.translations.registrationForm.campusOptions['Sint-Jacob'] ?? 'Sint-Jacob',
		},
		'Thomas More Antwerpen': {
			National: window.translations.registrationForm.campusOptions.National ?? 'National',
			Sanderus: window.translations.registrationForm.campusOptions.Sanderus ?? 'Sanderus',
			'Sint-Andries': window.translations.registrationForm.campusOptions['Sint-Andries'] ?? 'Sint-Andries',
		},
		'Universiteit Antwerpen': {
			'Drie Eiken': window.translations.registrationForm.campusOptions['Drie Eiken'] ?? 'Drie Eiken',
			Groenenborger: window.translations.registrationForm.campusOptions.Groenenborger ?? 'Groenenborger',
			Middelheim: window.translations.registrationForm.campusOptions.Middelheim ?? 'Middelheim',
			Stadscampus: window.translations.registrationForm.campusOptions.Stadscampus ?? 'Stadscampus',
		},
	};

	parent?.addEventListener( 'change', ( e ) => {
		const target = e.target;
		if ( !target || !( target instanceof HTMLSelectElement ) || !target.matches( 'select#school' ) ) {
			return;
		}

		const campusSelect = document.querySelector<HTMLSelectElement>( 'select#campus' );
		if ( !campusSelect ) {
			return;
		}

		const campusSelectLabel = document.querySelector<HTMLLabelElement>( 'label[for="campus"]' );

		// reset to empty and hidden state
		{
			campusSelect.setAttribute( 'hidden', '' );
			campusSelectLabel?.setAttribute( 'hidden', '' );

			if ( campusSelect.value && campusSelect.value !== 'Andere' ) {
				campusSelect.value = '';
				campusSelect.setAttribute( 'data-value', '' );
			}

			const campusOptions = Array.from( document.querySelectorAll<HTMLSelectElement>( 'select#campus option' ) ).filter( ( x ) => {
				return !( x.hasAttribute( 'data-option-is-default' ) || x.hasAttribute( 'data-option-is-other' ) );
			} );
			campusOptions.forEach( ( x ) => {
				x.remove();
			} );
		}

		// assign campuses for selected school
		{
			const campusOptionOther = document.querySelector<HTMLSelectElement>( 'select#campus option[data-option-is-other]' );

			const campuses = campusesBySchool[target.value];

			if ( !campuses || !Object.keys( campuses ).length ) {
				campusSelect.value = 'Andere';
				campusSelect.setAttribute( 'data-value', 'Andere' );

				campusSelect.removeAttribute( 'hidden' );
				campusSelectLabel?.removeAttribute( 'hidden' );

				return;
			}

			for ( const campus in campuses ) {
				if ( !Object.hasOwn( campuses, campus ) ) continue;

				const campusTranslation = campuses[campus];

				const option = document.createElement( 'option' );
				option.value = campus;
				option.textContent = campusTranslation;

				if ( campusOptionOther ) {
					campusSelect.insertBefore( option, campusOptionOther );
				} else {
					campusSelect.appendChild( option );
				}
			}

			campusSelect.removeAttribute( 'hidden' );
			campusSelectLabel?.removeAttribute( 'hidden' );
		}
	} );

	return html`
		<form
			name="form"
			class="form"
			@submit=${handleSubmit}
		>
			<div class="form-group">
				<label class="form-label" for="user_email">
					${window.translations.registrationForm.emailAddress}
				</label>

				<input
					id="user_email"
					name="email"
					type="email"
					class="form-input"
					required
				>
			</div>

			<div class="form-group">
				<label class="form-label" for="first_name">
					${window.translations.registrationForm.firstName}
				</label>

				<input
					id="first_name"
					name="firstName"
					type="text"
					class="form-input"
					required
				>
			</div>

			<div class="form-group">
				<label class="form-label" for="last_name">
					${window.translations.registrationForm.lastName}
				</label>

				<input
					id="last_name"
					name="lastName"
					type="text" class="form-input"
					required
				>
			</div>

			<div class="form-group">
				<label class="form-label" for="student_number">
					${window.translations.registrationForm.studentNumber}
				</label>

				<input
					id="student_number"
					name="studentNumber"
					type="text"
					class="form-input"
					required
				>
			</div>

			<div class="form-group">
				<label class="form-label" for="school">
					${window.translations.registrationForm.school}
				</label>

				<select
					class="form-input form-input--select"
					id="school"
					name="school"
					onchange="this.setAttribute('data-value', this.value)"
					required
				>
					<option value="" disabled selected>${window.translations.registrationForm.selectOption}</option>
					<option value="Antwerp Maritime Academy">${window.translations.registrationForm.schoolOptions[0]}</option>
					<option value="Artesis Plantijn Hogeschool Antwerpen">${window.translations.registrationForm.schoolOptions[1]}</option>
					<option value="Karel de Grote Hogeschool">${window.translations.registrationForm.schoolOptions[2]}</option>
					<option value="KU Leuven Antwerpen">${window.translations.registrationForm.schoolOptions[3]}</option>
					<option value="Thomas More Antwerpen">${window.translations.registrationForm.schoolOptions[4]}</option>
					<option value="Universiteit Antwerpen">${window.translations.registrationForm.schoolOptions[5]}</option>
					<option value="Andere">${window.translations.registrationForm.other}</option>
				</select>

				<label class="form-label" for="school-other">
					<span class="u-visually-hidden">
						${window.translations.registrationForm.other}
					</span>
				</label>

				<input
					class="form-input"
					id="school-other"
					name="schoolOther"
					type="text"
				>

				<style>
					[for="school-other"],
					#school-other {
						margin-block-start: 0.5rem;
					}

					#school:not([data-value="Andere"]) ~ [for="school-other"],
					#school:not([data-value="Andere"]) ~ #school-other {
						display: none;
					}
				</style>
			</div>

			<div class="form-group">
				<label class="form-label" for="campus" hidden>
					${window.translations.registrationForm.campus}
				</label>

				<select
					class="form-input form-input--select"
					id="campus"
					name="campus"
					onchange="this.setAttribute('data-value', this.value)"
					hidden
				>
					<option value="" disabled selected data-option-is-default>${window.translations.registrationForm.selectOption}</option>
					<option value="Andere" data-option-is-other>${window.translations.registrationForm.other}</option>
				</select>

				<label class="form-label" for="campus-other">
					<span class="u-visually-hidden">
						${window.translations.registrationForm.other}
					</span>
				</label>

				<input
					class="form-input"
					id="campus-other"
					name="campusOther"
					type="text"
				>

				<style>
					[for="campus-other"],
					#campus-other {
						margin-block-start: 0.5rem;
					}

					#campus:not([data-value="Andere"]) ~ [for="campus-other"],
					#campus:not([data-value="Andere"]) ~ #campus-other {
						display: none;
					}
				</style>
			</div>

			<div class="form-group">
				<label class="form-label" for="academic-year">
					${window.translations.registrationForm.academicYear}
				</label>

				<select
					class="form-input form-input--select"
					id="academic-year"
					name="academicYear"
					onchange="this.setAttribute('data-value', this.value)"
					required
				>
					<option value="" disabled selected>${window.translations.registrationForm.selectOption}</option>
					<option value="1e Ba">${window.translations.registrationForm.academicYearOptions[0]}</option>
					<option value="1e Ma">${window.translations.registrationForm.academicYearOptions[1]}</option>
					<option value="2e Ba">${window.translations.registrationForm.academicYearOptions[2]}</option>
					<option value="2e Ma">${window.translations.registrationForm.academicYearOptions[3]}</option>
					<option value="3e Ba">${window.translations.registrationForm.academicYearOptions[4]}</option>
					<option value="3e Ma">${window.translations.registrationForm.academicYearOptions[5]}</option>
					<option value="Ba-na-Ba">${window.translations.registrationForm.academicYearOptions[6]}</option>
					<option value="Ma-na-Ma">${window.translations.registrationForm.academicYearOptions[7]}</option>
					<option value="Schakelprogramma">${window.translations.registrationForm.academicYearOptions[8]}</option>
					<option value="Graduaat">${window.translations.registrationForm.academicYearOptions[9]}</option>
					<option value="Andere">${window.translations.registrationForm.other}</option>
				</select>

				<label class="form-label" for="academic-year-other">
					<span class="u-visually-hidden">
						${window.translations.registrationForm.other}
					</span>
				</label>

				<input
					class="form-input"
					id="academic-year-other"
					name="academicYearOther"
					type="text"
				>

				<style>
					[for="academic-year-other"],
					#academic-year-other {
						margin-block-start: 0.5rem;
					}

					#academic-year:not([data-value="Andere"]) ~ [for="academic-year-other"],
					#academic-year:not([data-value="Andere"]) ~ #academic-year-other {
						display: none;
					}
				</style>
			</div>

			<div class="form-group">
				<label class="form-label" for="study-area">
					${window.translations.registrationForm.studyArea}
				</label>

				<select
					class="form-input form-input--select"
					id="study-area"
					name="studyArea"
					onchange="this.setAttribute('data-value', this.value)"
					required
				>
					<option value="" disabled selected>${window.translations.registrationForm.selectOption}</option>
					<option value="Bedrijf & Organisatie">${window.translations.registrationForm.studyAreaOptions[0]}</option>
					<option value="Gezondheid">${window.translations.registrationForm.studyAreaOptions[1]}</option>
					<option value="IT">${window.translations.registrationForm.studyAreaOptions[2]}</option>
					<option value="Kunst & Design">${window.translations.registrationForm.studyAreaOptions[3]}</option>
					<option value="Mens & Maatschappij">${window.translations.registrationForm.studyAreaOptions[4]}</option>
					<option value="Onderwijs">${window.translations.registrationForm.studyAreaOptions[5]}</option>
					<option value="Talen & Communicatie">${window.translations.registrationForm.studyAreaOptions[6]}</option>
					<option value="Wetenschap">${window.translations.registrationForm.studyAreaOptions[7]}</option>
					<option value="Andere">${window.translations.registrationForm.other}</option>
				</select>

				<label class="form-label" for="study-area-other">
					<span class="u-visually-hidden">
						${window.translations.registrationForm.other}
					</span>
				</label>

				<input
					class="form-input"
					id="study-area-other"
					name="studyAreaOther"
					type="text"
				>

				<style>
					[for="study-area-other"],
					#study-area-other {
						margin-block-start: 0.5rem;
					}

					#study-area:not([data-value="Andere"]) ~ [for="study-area-other"],
					#study-area:not([data-value="Andere"]) ~ #study-area-other {
						display: none;
					}
				</style>
			</div>

			<div class="form-group">
				<label class="form-label" for="education">
					${window.translations.registrationForm.education}
				</label>

				<input
					id="education"
					name="education"
					type="text"
					class="form-input"
					required
				>
			</div>

			<div class="form-group form-checkbox">
				<input
					id="communication_opt_in"
					name="communicationOptIn"
					type="checkbox"
				>

				<label for="communication_opt_in">
					${window.translations.registrationForm.communicationOptIn1}
					<br><br>
					${window.translations.registrationForm.communicationOptIn2}
				</label>

				${privacyPolicyLinkHTML}
			</div>

			<div class="form-group form-checkbox">
				<input
					id="accept_terms"
					name="accept_terms"
					type="checkbox"
					required
				>

				<label for="accept_terms">${window.translations.registrationForm.acceptTerms}</label>

				${termsAndConditionsLinkHTML}
			</div>

			${feedback}

			<div class="form-group">
				<button
					class="button"
					type="submit"
					name="submit"
				>
					${window.translations.registrationForm.registerButton}
				</button>
			</div>
		</form>
	`;
}

export function renderVisitorRegistrationSuccess(): TemplateResult {
	return html`
		<div class="text-page__content u-centered">
			${window.translations.successMessages.ok}
		</div>
	`;
}
